import React, { useState, useContext } from 'react';
import {
  SafeAreaView,
  StyleSheet,
  View,
  Text,
  TextInput, 
  Button,
  Image,
  Alert,
  TouchableOpacity,
} from 'react-native';
import { AuthContext } from '../Contexts/ContextUsuario';
import firebase from 'firebase';

// Inicializar o Firebase
var app = firebase.app();

var db = app.database();
var auth = app.auth();

var valor;

const TelaLogin = (props) => {
  const [userName, setUserName] = React.useState('');
  const [userPassoword, setUserPassoword] = useState('');
  const { state, actions } = useContext(AuthContext);



  function comparaDatabase() {


    auth.signInWithEmailAndPassword(userName + "@maristavirtual.org.br", userPassoword).then(() =>{
      db.ref('usuarios/' + userName).once('value').then(async (snapshot) => {
        
          valor = await snapshot.val();

          if(valor.pedido == null || valor.pedido == '' || valor.pedido == ' ' || valor.pedido   == undefined){
            actions.setUser({ 
              name: userName,
              saldo: valor.saldo,
              numpedido: ['Você não tem nenhum.']
            });
          } else {
            actions.setUser({ 
              name: userName,
              saldo: valor.saldo,
              numpedido: Object.keys(valor.pedido)
            });  
          }
          props.navigation.navigate('PAGINA INICIAL')
      }).catch((err) =>{
        console.log(err)
        if(err.code == "auth/operation-not-allowed"){
          alert('É possível que o servidor esteja passando por atualizações.\nPor favor contate o suporte.')
        }
        else if(err.code == "auth/project-not-found "){
          alert('É possível que o servidor esteja passando por atualizações.\nPor favor contate o suporte.')
        }
        else if(err.code == "auth/uid-already-exists"){
          alert('Erro no usuário.\nPor favor contate o suporte.')
        }
        else if(err.code == "auth/user-not-found"){
          alert('Usuário não encontrado.\nCadastre-se primeiro.')
        }
        else if(err.code == "auth/invalid-email"){
          alert('Email inválido.\nTente novamente.')
        }
        else if(err.code == "auth/invalid-password" || err.code == "auth/wrong-password"){
          alert('Senha incorreta')
        }
        else if(err.code == "auth/internal-error"){
          alert('Erro interno.\nTente novamente mais tarde.')
        }
        else {
          console.log(err)
          alert(`Ocorreu um erro: ${err.message}\nCódigo de erro: ${err.code}`)
        }
      })
    }).catch((err) =>{
      console.log(err)
      if(err.code == "auth/user-not-found"){
        alert('Usuário não encontrado.\nCadastre-se primeiro.')
      } else {
        alert(`Ocorreu um erro: ${err.message}\nCódigo de erro: ${err.code}`)
      }
    })

    
  }


  const handleLogin = () => {
    comparaDatabase()
  }

  function handleRedefinir(){ 
    auth.sendPasswordResetEmail(userName + "@maristavirtual.org.br").then(() => {
      alert(`Um email de redefinição de senha foi enviado para ${userName}@maristavirtual.org.br`)
    }).catch((err) => {
      if(err.code == "auth/invalid-email"){
        alert(`O endereço de email é inválido`)
      }
      else if(err.code == "auth/user-not-found"){
        alert(`Este endereço de email não está cadastrado`)
      }
      else{
        alert('Ocorreu um erro:', `${err.message}\nCódigo de erro: ${err.code}`)
      }

    });
  }

  const handleCadastro = () => {
    props.navigation.navigate('CADASTRO')
  }


  return (
    <View style={Style.container}>

      <View style={Style.LogoSpace}>
        <Image
          style={Style.CantinaSantaClara}
          source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/809404531241779240/logoCantina.png'}}
        />
      </View>

      <View style={Style.LoginSpace}>
        
        <View style={Style.TypingSpace}>

          <Text style={Style.LoginText}>
            LOGIN
          </Text>
          
          
          <View style={Style.TypingLayout}>
            <Image
              style={Style.Icon}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/804330284513492992/IconePerfil.PNG'}}
            />

            <TextInput
              keyboardType="email-address"
              onChangeText={username => setUserName(username)}
              value={userName}
              placeholder={'Usuário'}
              style={Style.InputText}
            />
          </View>


          <View style={Style.TypingLayout}>
          <Image
              style={Style.Icon}
              source={{uri: 'https://cdn.discordapp.com/attachments/804330188602605588/811744999451787274/passwordIcon.PNG'}}
            />

            <TextInput
              secureTextEntry={true}
              value={userPassoword}
              onChangeText={(userpassoword) => setUserPassoword(userpassoword)}
              placeholder={'Senha'}
              style={Style.InputText}
            />
          </View>


          <TouchableOpacity
            style={Style.ButtonLogin}
            onPress={handleLogin}>

            <Text style={Style.ButtonLoginText}> Entrar </Text>
          </TouchableOpacity>


          <TouchableOpacity
            style={Style.ButtonRegister}
            onPress={handleCadastro}>

            <Text style={Style.ButtonRegisterText}> Criar uma conta </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={Style.ButtonRegister}
            onPress={handleRedefinir}>

            <Text style={Style.ButtonRegisterText}> Esqueci a senha </Text>
          </TouchableOpacity>

        </View>
      </View>
    </View>

  );
}



const Style = StyleSheet.create({
  container: {
    flexDirection: 'column',

    width: '100%',
    height: '100%',

    backgroundColor: 'rgba(179, 179, 179, 255)',
  },

  LogoSpace:{
    flexDirection: 'row',
    justifyContent: 'center',

    marginTop: '5%',
  },

  LoginSpace: {
    flexDirection: 'row',
    justifyContent: 'center',

    width: '100%',
    height: '100%',
  },

  TypingSpace: {
    justifyContent: 'center',
    alignItems: 'center',

    width: '85%',
    height: 420,

    marginTop: '5%',

    borderRadius: 20,

    backgroundColor: 'rgba(112, 112, 112, 255)',
  },

  LoginText: {
    fontFamily: 'System',
    fontSize: 18,

    color: 'rgba(255, 255, 255, 255)',
  },

  InputText: {
    marginStart: 15,

    width: '80%',
    height: '100%',
  },

  CantinaSantaClara: {
    height: 160,
    width: 260,

    marginTop: 30,
  },

  ButtonLogin: {
    justifyContent: 'center',

    width: '80%',
    height: '15%',

    marginTop: 25,
    borderRadius: 20,
    
    backgroundColor: 'rgba(0, 58, 109, 255)',

  },

  ButtonLoginText: {
    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 17,

    color: 'rgba(255, 255, 255, 255)',
  },

  ButtonRegisterText: {
    textAlign: 'center',

    fontFamily: 'System',
    fontSize: 13,

    color: 'rgba(255, 255, 255, 255)',
  },

  ButtonRegister: {
    marginTop: 20,
  },

  TypingLayout: {
    flexDirection: 'row',
    alignItems: 'center',

    width: '95%',
    height: '15%',

    marginTop: 25,
    borderRadius: 20,

    backgroundColor: 'rgba(255, 255, 255, 255)',
  },

  Icon: {
    height: 25,
    width: 25,

    marginStart: 15,
  },
});

export default TelaLogin;